import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { ParentContentCardMultiHeader } from '../common/ParentContentCardMultiHeader';
import { FileUpload } from '../../common/formElements/FileUpload';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import voca from 'voca';
import { drapcodeIcon } from '../../common/custom/icon-library';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import showAlert from '../../common/utils/alert';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { RESOURCE } from 'drapcode-constant';

export class Resources extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  clipboardStyle = {
    cursor: 'pointer',
    padding: '4px',
    verticalAlign: 'middle',
    margin: 0,
  };

  copyToClipboard = () => {
    toast.success('Copied to clipboard');
  };
  state = {
    toggleUpload: false,
  };
  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
    actions.loadAllResources({ projectId });
  }
  toggleField = (value) => {
    this.setState({ toggleUpload: value });
  };
  handleDelete = async (uuid) => {
    // const { actions, projectId } = this.props;
    const { match, actions } = this.props;
    const { projectId } = match.params;
    const preConfirm = async () => {
      await actions.deleteResources({ projectId, uuid });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
    await actions.loadAllResources({ projectId });
  };
  render() {
    const { actions, appSetting, match } = this.props;
    const { projectId, version } = match.params;
    const { deleteResourcesPending, projectDetail, permissionFlags } = appSetting;
    const resources = appSetting.allResources ? appSetting.allResources : null;
    const { toggleUpload } = this.state;
    if (!projectDetail) {
      return '';
    }

    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const deleteFlag = permissionsArray.includes(RESOURCE);
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'resources'} projectDetail={projectDetail} />
        <ParentContentCardMultiHeader
          isSearch={false}
          btnSize="sm"
          title="Resources"
          icon="resources"
          bgColor="drapcode-violet"
          projectId={projectId}
          version={version}
          CtaComponent={
            <>
              <button
                onClick={() => this.toggleField(true)}
                className="btn btn-theme-submit btn-md"
                title={'Upload Resource'}
              >
                <i className="wb webconnect-plus" /> Upload Resource
              </button>
            </>
          }
        >
          <Modal isOpen={toggleUpload} toggle={() => this.toggleField(false)} backdrop="static">
            <ModalHeader toggle={() => this.toggleField(false)} className="border-bottom">
              <strong>Upload Resource Files</strong>
            </ModalHeader>
            <ModalBody className="d-flex flex-column justify-content-center align-items-center">
              <FileUpload
                url={`${process.env.REACT_APP_BUILDER_ENGINE}resource/upload-file`}
                projectId={projectId}
                maxFiles={1}
                maxSizeBytes="52428800"
                fileIcon="customTheme"
                submitAction={() => actions.loadAllResources({ projectId })}
              />
            </ModalBody>
          </Modal>
          {resources && resources.length > 0 && (
            <table className="table table-bordered table-hover table-sm table-word-break">
              <thead>
                <tr>
                  <th title="Index">#</th>
                  <th title="URL/Link Tag" className="w-80">
                    URL/Link Of Resources
                  </th>
                  <th title="Action">Action</th>
                </tr>
              </thead>
              <tbody>
                {resources.map((file, index) => {
                  return (
                    <tr key={file.uuid} className="text-left">
                      <td className="align-middle">{index + 1}</td>
                      <td className="align-middle" title={file.file.URL}>
                        <CopyToClipboard
                          text={file.file ? file.file.URL : ''}
                          onCopy={() => {
                            this.copyToClipboard(file.file.URL);
                          }}
                          title={'Copy to clipboard'}
                          style={this.clipboardStyle}
                        >
                          <span>
                            {voca.first(file.file.URL, 65)}...
                            {voca.last(file.file.URL, 45)}{' '}
                            <i className="webconnect webconnect-files" />
                          </span>
                        </CopyToClipboard>
                      </td>
                      <td className="text-center">
                        &nbsp;
                        <button
                          className="btn btn-xs btn-theme-delete"
                          style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
                          onClick={() => (deleteFlag ? this.handleDelete(file.uuid) : undefined)}
                          title={`Delete URL/Link`}
                          disabled={deleteResourcesPending}
                        >
                          <i className={`wb ${drapcodeIcon('delete')}`}></i>&nbsp;
                          {deleteFlag ? null : (
                            <TooltipInfo
                              title={description}
                              headerText={`Permission Disabled!`}
                              showHeader={true}
                              showArrow={true}
                            />
                          )}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </ParentContentCardMultiHeader>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Resources);
